import request, {
  convertData,
  MutationOptions,
  useMakeMutation,
} from '@shared/innmaxLib/services'
import React from 'react'
import { useQuery, UseQueryOptions } from 'react-query'
import { useConvertFeedback } from './feedback.converter'
import { IFeedback } from './feedback.type'

export const useFeedbackList = (query?: any, options?: UseQueryOptions) => {
  const { converter } = useConvertFeedback()

  const { data, ...others } = useQuery(
    ['/customerFeedback/list/{pageNum}/{pageSize}', query],
    {
      ...options,
    }
  )

  const dataSource = React.useMemo(() => {
    return convertData<IFeedback>(
      {
        converter,
      },
      data
    )
  }, [data, converter])

  return {
    ...others,
    dataSource,
    loading: others.isLoading,
  }
}

export const useFeedbackById = (id?: string, options?: UseQueryOptions) => {
  const { converter } = useConvertFeedback()

  const { data: _data, ...others } = useQuery(
    ['/customerFeedback/detail/{id}', { id }],
    {
      enabled: !!id,
      ...options,
    }
  )

  const data = React.useMemo(() => {
    return converter((_data as any)?.data)
  }, [_data, converter])

  return {
    ...others,
    data,
    loading: others.isLoading,
  }
}

export const useAddFeedback = (options: MutationOptions = {}) => {
  return useMakeMutation(
    (values: Partial<any> = {}) =>
      request('/customerFeedback', {
        method: 'POST',
        body: values,
      }),
    options
  )
}

export const useEditFeedback = (options: MutationOptions = {}) => {
  return useMakeMutation(
    (values: Partial<any> = {}) =>
      request(`/customerFeedback`, {
        method: 'PUT',
        body: values,
      }),
    options
  )
}
